module.exports = __webpack_public_path__ + "static/media/is.64b6d7d9.svg";